import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { Router, ActivatedRoute } from '@angular/router';

declare var $: any, moment: any

@Component({
  selector: 'app-status-tracking',
  templateUrl: './status-tracking.component.html',
  styleUrls: ['./status-tracking.component.scss']
})
export class StatusTrackingComponent implements OnInit {

  menuEnabled = false
  contactDros: any = {}

  contact: any = {}
  disablebtnSave = false
  contactId = ""
  dpa_idcard = ""
  telephone1 = ""

  PortalUser: any;
  constructor(
    private Api: ApiService,
    private Util: UtilService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  async ngOnInit() {
    this.Util.ShowWaiting(true)

    $('*[data-toggle="collapse"]').on("click", function () {
      if ($(this).hasClass("collapsed")) {
        const iconBtn = $(this).find(".fa-chevron-circle-down")[0]
        $(iconBtn).removeClass("fa-chevron-circle-down").addClass("fa-chevron-circle-up")
      }
      else {
        const iconBtn = $(this).find(".fa-chevron-circle-up")[0]
        $(iconBtn).removeClass("fa-chevron-circle-up").addClass("fa-chevron-circle-down")
      }
    });


    let config: any = await this.Api.get("master", "configuration")
    let crisisConfig: any = config.filter((c: any) => {
      return c.dpa_name == "CRISIS FLAG"
    })

    let isCrisis: any
    if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
      isCrisis = true
    }
    else {
      isCrisis = false
    }


    let menuList: any = await this.Api.get("master", "customerPortalMenuSetting")
    //this.Util.ShowWaiting(false)
    let thisMenu: any = this.Util.getMenuObj(menuList, "05", isCrisis)
    if (!thisMenu.show) {
      this.Util.ShowWaiting(false)
      setTimeout(() => {
        this.router.navigate(["mainmenu/index"])
      }, 500);
      return
    }
    else {
      this.menuEnabled = true
    }

    this.PortalUser = JSON.parse(localStorage.getItem("dpa_portal"));
    if (this.PortalUser == null || this.PortalUser.contactid == null || this.PortalUser.contactid == "") {

      this.disablebtnSave = false;
      this.Util.WarningDialog("กรุณาเข้าสู่ระบบ");
      let thisTs = this
      $("#btnWarningOK").on('click', function () {
        thisTs.router.navigate(["mainmenu/login"])
      });
    }
    else {
      let userDetail: any = await this.Api.get("crmservice", "contact", "contactid=" + this.PortalUser.contactid)
      $("#IdNo").val(userDetail[0].dpa_idcard)
      $("#AccNo").val(userDetail[0].dpa_accountno)
      this.disablebtnSave = true;

      this.contactId = this.PortalUser.contactid;
      //this.contact = await this.getContact();
      //await this.getDROS();
      await this.GetResult();
      this.Util.ShowWaiting(false)
    }

  }

  drawTableStatus() {
    $("#tbStatus tbody").empty()
    try {
      $('#tbStatus').DataTable().clear().destroy();
    }
    catch (e) {

    }
    try {

      //console.log(this.contactDros);

      if (this.contactDros != null && this.contactDros.CRM03 != null) {
        let index = -1

        //let arr1 = this.contactDros.CRM03.map((obj: any) => { return { ...obj, date: new Date(obj.ModifyDate) }; });
        let arr1 = this.contactDros.CRM03;
        arr1.sort((firstObject: any, secondObject: any) => (secondObject.RequestTypeCode - firstObject.RequestTypeCode
          || new Date(secondObject.ModifyDate.substring(0, 19)).getTime() - new Date(firstObject.ModifyDate.substring(0, 19)).getTime()
        ));
        // let sortedDesc = arr1.sort((objA: any, objB: any) => objB.date.getTime() - objA.date.getTime());
        arr1.forEach((c: any) => {
          if (c.StatusDefinitionCustPortal != null){
            index++
  
            let tr = ""
  
            tr += '<tr id="' + index + '">'
            tr += '<td>' + c.RequestedNo + '</td>'
            tr += '<td>' + c.RequestType + '</td>'
            tr += '<td>' + c.StatusDefinitionCustPortal + '</td>'
            //tr += '<td>' + c.ProcessDefinition + '</td>'
            //tr += '<td>' + c.DisplayMessage + '</td>'
            tr += '<td>' + this.Util.transformDate(c.ModifyDate, "shortWithTime") + '</td>'
            tr += '</tr>'
  
            $("#tbStatus tbody").append(tr);
          }
        });
      }
    }
    catch (e) {
      console.log('draw table status error')
    }

    $("#tbStatus").dataTable({
      retrieve: true,
      'searching': false,
      'paginate': true,
      bAutoWidth: false,
      aoColumns: [
        { sWidth: '20%' },
        { sWidth: '20%' },
        { sWidth: '40%' },
        //{ sWidth: '20%' },
        { sWidth: '16%' }
      ],
      order: []
    });
  }



  async GetResult() {
    try {
      let thisTs = this
      if ($("#IdNo").val() == "" || $("#AccNo").val() == "") {
        this.Util.WarningDialog("กรุณาระบุเงื่อนไขการค้นหาให้ครบถ้วน");
        $("#btnWarningOK").on('click', function () {
          thisTs.router.navigate(["mainmenu/index"])
        });
        return;
      }

      let para = "idNo=" + $("#IdNo").val();
      let tmp: any = await this.Api.get("crmservice", "getDA", para);
      if (tmp != null) {
        if (tmp.FirstName != null && tmp.FirstName.trim().length > 0) {
          let BankList: any = await this.Api.get("master", "bank");
          let Bank: any = BankList.filter((a: any) => a.dpa_bankcode == tmp.FI_Code)[0];
          let EffectiveDate: any;
          try {
            if (Bank !== undefined && Bank != null) {

              if (Bank.dpa_effectivedate !== undefined && Bank.dpa_effectivedate != null) {
                EffectiveDate = new Date(Bank.dpa_effectivedate.substring(0, 10));
                EffectiveDate.setDate(EffectiveDate.getDate() + 5);
                this.Util.SuccessDialog("ท่านเป็นผู้ฝากที่มีรายชื่ออยู่กับ  สง. ที่ถูกเพิกถอนใบอนุญาต ซึ่ง สคฝ.อยู่ระหว่างการตรวจสอบข้อมูล และจะดำเนินการจ่ายคืนเงินให้กับผู้ฝากโดยเร็ว ภายในไม่เกิน 30 วัน หากท่านยังมิได้ผูกบัญชีพร้อมเพย์กับหมายเลขบัตรประจำตัวประชาชน ท่านสามารถดำเนินการดังกล่าวได้ เพื่อความสะดวก รวดเร็วยิ่งขึ้นในการรับคืนเงินฝาก ทั้งนี้ ท่านสามารถลงทะเบียนเพื่อติดตามความคืบหน้าของการจ่ายคืนด้วยตัวเอง ผ่าน Depositors Web ได้ตั้งแต่วันที่ " + this.Util.transformDate(EffectiveDate.toISOString().substring(0, 10), "short") + " เป็นต้นไป หรือสอบถามข้อมูลเพิ่มเติมได้ที่ DPA contact center 1158");
                $('#btnSuccessOK').on('click', function () {
                  thisTs.router.navigate(["mainmenu/index"])
                });
                return;
              }
            }
            else {
              EffectiveDate = moment().add(5, 'd');;
              this.Util.SuccessDialog("ท่านเป็นผู้ฝากที่มีรายชื่ออยู่กับ  สง. ที่ถูกเพิกถอนใบอนุญาต ซึ่ง สคฝ.อยู่ระหว่างการตรวจสอบข้อมูล และจะดำเนินการจ่ายคืนเงินให้กับผู้ฝากโดยเร็ว ภายในไม่เกิน 30 วัน หากท่านยังมิได้ผูกบัญชีพร้อมเพย์กับหมายเลขบัตรประจำตัวประชาชน ท่านสามารถดำเนินการดังกล่าวได้ เพื่อความสะดวก รวดเร็วยิ่งขึ้นในการรับคืนเงินฝาก ทั้งนี้ ท่านสามารถลงทะเบียนเพื่อติดตามความคืบหน้าของการจ่ายคืนด้วยตัวเอง ผ่าน Depositors Web ได้ตั้งแต่วันที่ " + this.Util.transformDate(EffectiveDate.toISOString().substring(0, 10), "short") + " เป็นต้นไป หรือสอบถามข้อมูลเพิ่มเติมได้ที่ DPA contact center 1158");

              $('#btnSuccessOK').on('click', function () {
                thisTs.router.navigate(["mainmenu/index"])
              });
              return;
            }
          }
          catch {
            EffectiveDate = moment().add(5, 'd');;
            this.Util.SuccessDialog("ท่านเป็นผู้ฝากที่มีรายชื่ออยู่กับ  สง. ที่ถูกเพิกถอนใบอนุญาต ซึ่ง สคฝ.อยู่ระหว่างการตรวจสอบข้อมูล และจะดำเนินการจ่ายคืนเงินให้กับผู้ฝากโดยเร็ว ภายในไม่เกิน 30 วัน หากท่านยังมิได้ผูกบัญชีพร้อมเพย์กับหมายเลขบัตรประจำตัวประชาชน ท่านสามารถดำเนินการดังกล่าวได้ เพื่อความสะดวก รวดเร็วยิ่งขึ้นในการรับคืนเงินฝาก ทั้งนี้ ท่านสามารถลงทะเบียนเพื่อติดตามความคืบหน้าของการจ่ายคืนด้วยตัวเอง ผ่าน Depositors Web ได้ตั้งแต่วันที่ " + this.Util.transformDate(EffectiveDate.toISOString().substring(0, 10), "short") + " เป็นต้นไป หรือสอบถามข้อมูลเพิ่มเติมได้ที่ DPA contact center 1158");

            $('#btnSuccessOK').on('click', function () {
              thisTs.router.navigate(["mainmenu/index"])
            });
            return;

          }
        }
      }

      let QueryString = "CRM02=true&CRM03=true&CRM04=true&CRM05=true&CRM07=true";
      if ($("#IdNo").val() != "")
        QueryString += "&dpa_id=" + $("#IdNo").val();
      if ($("#AccNo").val() != "")
        QueryString += "&dpa_accountno=" + $("#AccNo").val();
      let Res: any = await this.Api.get("crmservice", "contactDros", QueryString);
      if (Res == null) {
        console.log("ไม่พบข้อมูลdros")
        this.Util.WarningDialog("ไม่พบข้อมูล กรุณาติดต่อ Call Center DPA 1158");
        $('#btnWarningOK').on('click', function () {
          thisTs.router.navigate(["mainmenu/index"])
        });
      }
      else {
        if (Res.CRM07 == null || Res.CRM07.length == 0) {

          console.log("ไม่พบข้อมูล07")
          this.Util.WarningDialog("ไม่พบข้อมูล กรุณาติดต่อ Call Center DPA 1158");
          $('#btnWarningOK').on('click', function () {
            thisTs.router.navigate(["mainmenu/index"])
          });
          return;
        }
        else {
          Res.CRM07 = Res.CRM07.filter((a: any) => a.BankAccountNo == $("#AccNo").val());
          if (Res.CRM07 == null || Res.CRM07.length == 0) {
            console.log("ไม่พบข้อมูล0bank")
            this.Util.WarningDialog("ไม่พบข้อมูล กรุณาติดต่อ Call Center DPA 1158");
            $('#btnWarningOK').on('click', function () {
              thisTs.router.navigate(["mainmenu/index"])
            });
            return;
          }
        }
        $("#divProgress").empty();
        $("#lblInquiryResult1").html("");
        $("#lblInquiryResult2").html("");
        let StatusText1, StatusText2: any;
        let ProgressDiv, Progress1_1, Progress1_2, Progress1_3, Progress1_4, Progress1_5: any;
        let Progress2_1, Progress2_2, Progress2_3, Progress2_4, Progress2_5: any;
        let Progress3_1, Progress3_2, Progress3_3, Progress3_4, Progress3_5: any;
        let Progress4_1, Progress4_2, Progress4_3, Progress4_4, Progress4_5, Progress4_6: any;
        let Progress5_1, Progress5_2, Progress5_3, Progress5_4, Progress5_5: any;

        if (Res.CRM02.length > 0) {
          let arrCrm03 = this.contactDros.CRM03;

          Progress1_1 = "";  Progress1_2 = ""; Progress1_3 = "";  Progress1_4 = "";  Progress1_5 = "";
          Progress2_1 = "";  Progress2_2 = ""; Progress2_3 = "";  Progress2_4 = "";  Progress2_5 = "";
          Progress3_1 = "";  Progress3_2 = ""; Progress3_3 = "";  Progress3_4 = "";  Progress3_5 = "";
          Progress4_1 = "";  Progress4_2 = ""; Progress4_3 = "";  Progress4_4 = "";  Progress4_5 = ""; Progress4_6 = "";
          Progress5_1 = "";  Progress5_2 = ""; Progress5_3 = "";  Progress5_4 = "";  Progress5_5 = "";
          
          ProgressDiv = '';
          //let tmpTimeLine = '<div class="divider blue"></div>';
          //ProgressDiv = '<div class="row mt-4 text-center">';
          //ProgressDiv += '  <div class="col-md-12">';
          //ProgressDiv += '    <ul id="progressbarimg" class="progressbar-img content-center">';
          
          let returnFinish1_1 = false;
          let returnFinish1_2 = false;
          let returnFinish1_3 = false;
          let returnFinish1_4 = false;
          let returnFinish1_5 = false;
          let returnDate1_1 = "";
          let returnDate1_2 = "";
          let returnDate1_3 = "";
          let returnDate1_4 = "";
          let returnDate1_5 = "";
          let returnTXT1_1 = "";
          let returnTXT1_2 = "";
          let returnTXT1_3 = "";
          let returnTXT1_4 = "";
          let returnTXT1_5 = "";
          let lastFinish1 = false;
          let res02_type01 = Res.CRM02.filter((a: any) => a.RequestTypeCode == 1)
          if (res02_type01.length > 0) {
            res02_type01.sort((firstObject: any, secondObject: any) => (new Date(secondObject.ModifyDate.substring(0, 19)).getTime() - new Date(firstObject.ModifyDate.substring(0, 19)).getTime()
            ));
            let res03_type01 = Res.CRM03.filter((a: any) => a.RequestedNo == res02_type01[0].RequestedNo)

            if (res03_type01.length > 0) {
              if (res03_type01.filter((a: any) => a.ProcessStatusID == "101").length > 0) {
                returnFinish1_1 = true;
                returnDate1_1 = res03_type01.filter((a: any) => a.ProcessStatusID == "101")[0].ModifyDate;
                returnTXT1_1 = res03_type01.filter((a: any) => a.ProcessStatusID == "101")[0].StatusDefinitionCustPortal;
              }

              if (res03_type01.filter((a: any) => a.ProcessStatusID == "601").length > 0) {
                returnFinish1_1 = true;
                returnDate1_1 = res03_type01.filter((a: any) => a.ProcessStatusID == "601")[0].ModifyDate;
                returnTXT1_1 = res03_type01.filter((a: any) => a.ProcessStatusID == "601")[0].StatusDefinitionCustPortal;
              }

              if (res03_type01.filter((a: any) => a.ProcessStatusID == "603").length > 0) {
                returnFinish1_1 = true;
                returnDate1_1 = res03_type01.filter((a: any) => a.ProcessStatusID == "603")[0].ModifyDate;
                returnTXT1_1 = res03_type01.filter((a: any) => a.ProcessStatusID == "603")[0].StatusDefinitionCustPortal;
              }

              if (res03_type01.filter((a: any) => a.ProcessStatusID == "610").length > 0) {
                returnFinish1_2 = true;
                returnDate1_2 = res03_type01.filter((a: any) => a.ProcessStatusID == "610")[0].ModifyDate;
                returnTXT1_2 = res03_type01.filter((a: any) => a.ProcessStatusID == "610")[0].StatusDefinitionCustPortal;
              }

              
              if (res03_type01.filter((a: any) => a.ProcessStatusID == "701").length > 0) {
                returnFinish1_3 = true;
                returnDate1_3 = res03_type01.filter((a: any) => a.ProcessStatusID == "701")[0].ModifyDate;
                returnTXT1_3 = res03_type01.filter((a: any) => a.ProcessStatusID == "701")[0].StatusDefinitionCustPortal;
              }
              
              if (res03_type01.filter((a: any) => a.ProcessStatusID == "703").length > 0) {
                returnFinish1_3 = true;
                returnDate1_3 = res03_type01.filter((a: any) => a.ProcessStatusID == "703")[0].ModifyDate;
                returnTXT1_3 = res03_type01.filter((a: any) => a.ProcessStatusID == "703")[0].StatusDefinitionCustPortal;
              }

              if (res03_type01.filter((a: any) => a.ProcessStatusID == "603").length > 1) {
                returnFinish1_4 = true;
                returnDate1_4 = res03_type01.filter((a: any) => a.ProcessStatusID == "603")[0].ModifyDate;
                returnTXT1_4 = res03_type01.filter((a: any) => a.ProcessStatusID == "603")[0].StatusDefinitionCustPortal;
              }

              if (res03_type01.filter((a: any) => a.ProcessStatusID == "608").length > 0) {
                if (Res.CRM04.filter((a: any) => a.RequestedNo == res03_type01[0].RequestedNo && a.ChequeNo != "")) {
                  returnFinish1_5 = true;
                  returnDate1_5 = res03_type01.filter((a: any) => a.ProcessStatusID == "608" && a.RequestedNo == res02_type01[0].RequestedNo)[0].ModifyDate;
                  returnTXT1_5 = res03_type01.filter((a: any) => a.ProcessStatusID == "608" && a.RequestedNo == res02_type01[0].RequestedNo)[0].StatusDefinitionCustPortal;
                }
              }

              if (res03_type01.filter((a: any) => a.ProcessStatusID == "609").length > 0) {
                returnFinish1_5 = true;
                returnDate1_5 = res03_type01.filter((a: any) => a.ProcessStatusID == "609")[0].ModifyDate;
                returnTXT1_5 = res03_type01.filter((a: any) => a.ProcessStatusID == "609" && a.RequestedNo == res02_type01[0].RequestedNo)[0].StatusDefinitionCustPortal;
              }
            }

            if (returnFinish1_1){
              Progress1_1 = ' <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate1_1, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate1_1, "shortWithTime") + '</div><p>อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</p></div>';
              
              if (returnTXT1_1 == '')
                Progress1_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT1_1 + '</label></div></li>';
              else
                 Progress1_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription1_1">รายละเอียด</label><label id="txtDescription1_1" class="collapse" style="padding-left:64px;">'+ returnTXT1_1 + '</label></div></div></li>';
             
              //Progress1_1 = '      <li class="active step0" style="width: 12% !important" ><img width="61" style="background-color: white;padding-top:20px;" src="../../assets/images/circle.png"><br><label class="text status-active">อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</label></li>';
              //Progress2 += '      <label class="text status-active">จ่ายคืน</label>'; 
            }

            if (returnFinish1_2) {
              let d1 = this.Util.transformDate(returnDate1_1, "shortWithTime");
              let d2 = this.Util.transformDate(returnDate1_2, "shortWithTime");
              if (d1 == '')
                d1 = d2;

              Progress1_1 = ' <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d1 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d1 + '</div><p>อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</p></div>';
              Progress1_2 = ' <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d2 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle.png"><div class="divStep"><div class="divTimeTimeLine">' + d2 + '</div><p>จ่ายเงินคุ้มครองไม่สำเร็จ</p></div>';
              
              if (returnTXT1_1 == '')
                Progress1_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT1_1 + '</label></div></li>';
              else
                Progress1_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription1_1">รายละเอียด</label><label id="txtDescription1_1" class="collapse" style="padding-left:64px;">'+ returnTXT1_1 + '</label></div></div></li>';
              
              if (returnTXT1_2 == '')
                Progress1_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT1_2 + '</label></div></li>';
              else
                Progress1_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription1_2">รายละเอียด</label><label id="txtDescription1_2" class="collapse" style="padding-left:64px;">'+ returnTXT1_2 + '</label></div></div></li>';

              //Progress1_1 = '      <li class="active step0" style="width: 12% !important" ><img width="61" style="background-color: white;padding-top:20px;" src="../../assets/images/circle_1.png"><br><label class="text status-active">อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</label></li>';
              //Progress1_2 = '      <li class="active step0" style="width: 12% !important"><img width="61" style="background-color: white;padding-top:20px;" src="../../assets/images/circle.png"><br><label class="text status-active">จ่ายเงินคุ้มครองไม่สำเร็จ</label></li>';
              //Progress2 += '      <li class=""><label class="text status-active">จ่ายคืน</label></li>'; 
            }

            if (returnFinish1_3) {
              let d1 = this.Util.transformDate(returnDate1_1, "shortWithTime");
              let d2 = this.Util.transformDate(returnDate1_2, "shortWithTime");
              let d3 = this.Util.transformDate(returnDate1_3, "shortWithTime");
              if (d1 == '')
                d1 = d2;
              if (d2 == ''){
                d2 = d3; 
                d1 = d2;
              }

              Progress1_1 = ' <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d1 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d1 + '</div><p>อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</p></div>';
              Progress1_2 = ' <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d2 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d2 + '</div><p>จ่ายเงินคุ้มครองไม่สำเร็จ</p></div>';
              Progress1_3 = ' <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d3 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d3 + '</div><p>อยู่ระหว่างแก้ไขช่องทางการจ่ายเงิน</p></div>';
              
              //Progress1_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription">รายละเอียด</label><label id="txtDescription" class="collapse" style="padding-left:64px;">'+ returnTXT1_1 + '</label></div></div></li>';
              //Progress1_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription">รายละเอียด</label><label id="txtDescription" class="collapse" style="padding-left:64px;">'+ returnTXT1_2 + '</label></div></div></li>';
              //Progress1_3 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription">รายละเอียด</label><label id="txtDescription" class="collapse" style="padding-left:64px;">'+ returnTXT1_3 + '</label></div></div></li>';

              if (returnTXT1_1 == '')
                Progress1_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT1_1 + '</label></div></li>';
              else
                Progress1_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription1_1">รายละเอียด</label><label id="txtDescription1_1" class="collapse" style="padding-left:64px;">'+ returnTXT1_1 + '</label></div></div></li>';

              if (returnTXT1_2 == '')
                Progress1_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT1_2 + '</label></div></li>';
              else
                Progress1_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription1_2">รายละเอียด</label><label id="txtDescription1_2" class="collapse" style="padding-left:64px;">'+ returnTXT1_2 + '</label></div></div></li>';

              if (returnTXT1_3 == '')
                Progress1_3 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT1_3 + '</label></div></li>';
              else
                Progress1_3 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription1_3">รายละเอียด</label><label id="txtDescription1_3" class="collapse" style="padding-left:64px;">'+ returnTXT1_3 + '</label></div></div></li>';
    
              //Progress1_1 = '      <li class="active step0" style="width: 12% !important" ><img width="61" style="background-color: white;padding-top:20px;" src="../../assets/images/circle_1.png"><br><label class="text status-active">อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</label></li>';
              //Progress1_2 = '      <li class="active step0" style="width: 12% !important"><img width="61" style="background-color: white;padding-top:20px;" src="../../assets/images/circle_1.png"><br><label class="text status-active">จ่ายเงินคุ้มครองไม่สำเร็จ</label></li>';
              //Progress1_3 = '      <li class="active step0" style="width: 12% !important"><img width="61" style="background-color: white;padding-top:20px" src="../../assets/images/circle.png"><br><label class="text status-active">อยู่ระหว่างแก้ไขช่องทางการจ่ายเงิน</label></li>';
              //Progress2 += '      <label class="text status-active">จ่ายคืน</label>'; 
            }

            if (returnFinish1_4) {
              let d1 = this.Util.transformDate(returnDate1_1, "shortWithTime");
              let d3 = this.Util.transformDate(returnDate1_3, "shortWithTime");
              let d4 = this.Util.transformDate(returnDate1_4, "shortWithTime");
              if (d1 == '')
                d1 = d3;
              if (d3 == ''){
                d3 = d4; 
                d1 = d3;
              }

              Progress1_1 = ' <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d1 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d1 + '</div><p>อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</p></div>';
              Progress1_3 = ' <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d3 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d3 + '</div><p>อยู่ระหว่างแก้ไขช่องทางการจ่ายเงิน</p></div>';
              Progress1_4 = ' <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d4 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle.png"><div class="divStep"><div class="divTimeTimeLine">' + d4 + '</div><p>อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</p></div>';
              
              if (returnTXT1_1 == '')
                Progress1_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT1_1 + '</label></div></li>';
              else
                Progress1_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription1_1">รายละเอียด</label><label id="txtDescription1_1" class="collapse" style="padding-left:64px;">'+ returnTXT1_1 + '</label></div></div></li>';

              if (returnTXT1_4 == '')
                Progress1_4 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT1_4 + '</label></div></li>';
              else
                Progress1_4 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription1_4">รายละเอียด</label><label id="txtDescription1_4" class="collapse" style="padding-left:64px;">'+ returnTXT1_4 + '</label></div></div></li>';

              if (returnTXT1_3 == '')
                Progress1_3 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT1_3 + '</label></div></li>';
              else
                Progress1_3 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription1_3">รายละเอียด</label><label id="txtDescription1_3" class="collapse" style="padding-left:64px;">'+ returnTXT1_3 + '</label></div></div></li>';
    
              //Progress1_1 = '      <li class="active step0" style="width: 12% !important" ><img width="61" style="background-color: white;padding-top:20px;" src="../../assets/images/circle_1.png"><br><label class="text status-active">อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</label></li>';
              //Progress1_3 = '      <li class="active step0" style="width: 12% !important"><img width="61" style="background-color: white;padding-top:20px" src="../../assets/images/circle_1.png"><br><label class="text status-active">จ่ายเงินคุ้มครองไม่สำเร็จ</label></li>';
              //Progress1_4 = '      <li class="active step0" style="width: 12% !important"><img width="61" style="background-color: white;padding-top:20px" src="../../assets/images/circle.png"><br><label class="text status-active">อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</label></li>';
              //Progress2 += '      <li class=""><label class="text status-active">จ่ายคืน</label></li>'; 

            }
            
            if (returnFinish1_5) {
              let d5 = this.Util.transformDate(returnDate1_5, "shortWithTime");
              let d4 = this.Util.transformDate(returnDate1_4, "shortWithTime");
              if (d4 == '')
                d4 = d5;

              Progress1_4 = ' <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d4 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d4 + '</div><p>อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง </p></div>';
              Progress1_5 = ' <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d5 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d5 + '</div><p>จ่ายเงินคุ้มครองสำเร็จ </p></div>';
              
              if (returnTXT1_4 == '')
                Progress1_4 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT1_4 + '</label></div></li>';
              else
                Progress1_4 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription1_4">รายละเอียด</label><label id="txtDescription1_4" class="collapse" style="padding-left:64px;">'+ returnTXT1_4 + '</label></div></div></li>';

              if (returnTXT1_5 == '')
                Progress1_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT1_5 + '</label></div></li>';
              else
                Progress1_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription1_5">รายละเอียด</label><label id="txtDescription1_5" class="collapse" style="padding-left:64px;">'+ returnTXT1_5 + '</label></div></div></li>';

              
              //Progress1_1 = '      <li class="active step0" style="width: 12% !important" ><img width="61" style="background-color: white;padding-top:20px;" src="../../assets/images/circle_1.png"><br><label class="text status-active">อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</label></li>';
              //Progress1_4 = '      <li class="active step0" style="width: 12% !important"><img width="61" style="background-color: white;padding-top:20px" src="../../assets/images/circle_1.png"><br><label class="text status-active">อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</label></li>';
              //Progress1_5 = '      <li class="active step0" style="width: 12% !important"><img width="61" style="background-color: white;padding-top:20px" src="../../assets/images/circle_1.png"><br><label class="text status-active">จ่ายเงินคุ้มครองสำเร็จ</label></li>';
              //Progress2 += '      <li class=""><label class="text status-active">จ่ายคืน</label></li>'; 
              lastFinish1 = true;
            }

            /* if(returnFinish) 
             {
               Progress1 += '      <li class="active step0"><img width="101" style="background-color: white;" src="../../assets/images/checked.png"><br><label class="text status-active">จ่ายคืน</label></li>';  
             }
             else{
               Progress1 += '      <li class="active step0"><img width="101" style="background-color: white;" src="../../assets/images/rec.png"><br><label class="text status-active">จ่ายคืน</label></li>'; 
             }*/

          }

          let returntype2_1 = false;
          let returntype2_2 = false;
          let returntype2_3 = false;
          let returntype2_4 = false;
          let returntype2_5 = false;
          let returnDate2_1 = "";
          let returnDate2_2 = "";
          let returnDate2_3 = "";
          let returnDate2_4 = "";
          let returnDate2_5 = "";
          let returnTXT2_1 = "";
          let returnTXT2_2 = "";
          let returnTXT2_3 = "";
          let returnTXT2_4 = "";
          let returnTXT2_5 = "";
          let returnstep2 = false;
          let lastFinish2 = false;
          let res02_type02 = Res.CRM02.filter((a: any) => a.RequestTypeCode == 2)
          if (res02_type02.length > 0) {

            res02_type02.sort((firstObject: any, secondObject: any) => (new Date(secondObject.ModifyDate.substring(0, 19)).getTime() - new Date(firstObject.ModifyDate.substring(0, 19)).getTime()
            ));
            returnstep2 = true;
            let res03_type02 = Res.CRM03.filter((a: any) => a.RequestedNo == res02_type02[0].RequestedNo)
            if (res03_type02.length > 0) {
              
              lastFinish1 = false;
              
              if (res03_type02.filter((a: any) => a.ProcessStatusID == "301").length > 0) {
                returntype2_1 = true;
                returnDate2_1 = res03_type02.filter((a: any) => a.ProcessStatusID == "301")[0].ModifyDate;
                returnTXT2_1 = res03_type02.filter((a: any) => a.ProcessStatusID == "301")[0].StatusDefinitionCustPortal;
              }
              
              if (res03_type02.filter((a: any) => a.ProcessStatusID == "302").length > 0) {
                returntype2_1 = true;
                returnDate2_1 = res03_type02.filter((a: any) => a.ProcessStatusID == "302")[0].ModifyDate;
                returnTXT2_1 = res03_type02.filter((a: any) => a.ProcessStatusID == "302")[0].StatusDefinitionCustPortal;
              }

              if (res03_type02.filter((a: any) => a.ProcessStatusID == "303").length > 0) {
                returntype2_1 = true;
                returnDate2_1 = res03_type02.filter((a: any) => a.ProcessStatusID == "303")[0].ModifyDate;
                returnTXT2_1 = res03_type02.filter((a: any) => a.ProcessStatusID == "303")[0].StatusDefinitionCustPortal;
              }

              if (res03_type02.filter((a: any) => a.ProcessStatusID == "306").length > 0) {
                returntype2_1 = true;
                returnDate2_1 = res03_type02.filter((a: any) => a.ProcessStatusID == "306")[0].ModifyDate;
                returnTXT2_1 = res03_type02.filter((a: any) => a.ProcessStatusID == "306")[0].StatusDefinitionCustPortal;
              }
              
              if (res03_type02.filter((a: any) => a.ProcessStatusID == "1003").length > 0) {
                returntype2_1 = true;
                returnDate2_1 = res03_type02.filter((a: any) => a.ProcessStatusID == "1003")[0].ModifyDate;
                returnTXT2_1 = res03_type02.filter((a: any) => a.ProcessStatusID == "1003")[0].StatusDefinitionCustPortal;
              }


              if (res03_type02.filter((a: any) => a.ProcessStatusID == "713").length > 0) {
                returntype2_2 = true;
                returnDate2_2 = res03_type02.filter((a: any) => a.ProcessStatusID == "713")[0].ModifyDate;
                returnTXT2_2 = res03_type02.filter((a: any) => a.ProcessStatusID == "713")[0].StatusDefinitionCustPortal;
              }

              if (res03_type02.filter((a: any) => a.ProcessStatusID == "714" && a.FilePath != null).length > 0) {
                returntype2_2 = true;
                returnDate2_2 = res03_type02.filter((a: any) => a.ProcessStatusID == "714")[0].ModifyDate;
                returnTXT2_2 = res03_type02.filter((a: any) => a.ProcessStatusID == "714")[0].StatusDefinitionCustPortal;
              }

              if (res03_type02.filter((a: any) => a.ProcessStatusID == "715" && a.FilePath != null).length > 0) {
                returntype2_3 = true;
                returnDate2_3 = res03_type02.filter((a: any) => a.ProcessStatusID == "715")[0].ModifyDate;
                returnTXT2_3 = res03_type02.filter((a: any) => a.ProcessStatusID == "715")[0].StatusDefinitionCustPortal;
              }

              if (res03_type02.filter((a: any) => a.ProcessStatusID == "603").length > 0) {
                returntype2_4 = true;
                returnDate2_4 = res03_type02.filter((a: any) => a.ProcessStatusID == "603")[0].ModifyDate;
                returnTXT2_4 = res03_type02.filter((a: any) => a.ProcessStatusID == "603")[0].StatusDefinitionCustPortal;
              }


              if (res03_type02.filter((a: any) => a.ProcessStatusID == "608").length > 0) {
                if (Res.CRM04.filter((a: any) => a.RequestedNo == res03_type02[0].RequestedNo && a.ChequeNo != "").length > 0) {
                  returntype2_5 = true;
                  returnDate2_5 = res03_type02.filter((a: any) => a.ProcessStatusID == "608" && a.RequestedNo == res03_type02[0].RequestedNo)[0].ModifyDate;
                  returnTXT2_5 = res03_type02.filter((a: any) => a.ProcessStatusID == "608" && a.RequestedNo == res03_type02[0].RequestedNo)[0].StatusDefinitionCustPortal;
                }
              }

              if (res03_type02.filter((a: any) => a.ProcessStatusID == "609").length > 0) {
                returntype2_5 = true;
                returnDate2_5 = res03_type02.filter((a: any) => a.ProcessStatusID == "609")[0].ModifyDate;
                returnTXT2_5 = res03_type02.filter((a: any) => a.ProcessStatusID == "609")[0].StatusDefinitionCustPortal;
              }


            }
          }

          let returntype3_1 = false;
          let returntype3_2 = false;
          let returntype3_3 = false;
          let returntype3_4 = false;
          let returntype3_5 = false;
          let returnDate3_1 = "";
          let returnDate3_2 = "";
          let returnDate3_3 = "";
          let returnDate3_4 = "";
          let returnDate3_5 = "";
          let returnTXT3_1 = "";
          let returnTXT3_2 = "";
          let returnTXT3_3 = "";
          let returnTXT3_4 = "";
          let returnTXT3_5 = "";
          let lastFinish3 = false;
          let res02_type03 = Res.CRM02.filter((a: any) => a.RequestTypeCode == 3)
          if (res02_type03.length > 0) {

            res02_type03.sort((firstObject: any, secondObject: any) => (new Date(secondObject.ModifyDate.substring(0, 19)).getTime() - new Date(firstObject.ModifyDate.substring(0, 19)).getTime()
            ));
            returnstep2 = true;
            let res03_type03 = Res.CRM03.filter((a: any) => a.RequestedNo == res02_type03[0].RequestedNo)
            if (res03_type03.length > 0) {
              
              lastFinish1 = false;

              if (res03_type03.filter((a: any) => a.ProcessStatusID == "301").length > 0) {
                returntype3_1 = true;
                returnDate3_1 = res03_type03.filter((a: any) => a.ProcessStatusID == "301")[0].ModifyDate;
                returnTXT3_1 = res03_type03.filter((a: any) => a.ProcessStatusID == "301")[0].StatusDefinitionCustPortal;
              }
              
              if (res03_type03.filter((a: any) => a.ProcessStatusID == "302").length > 0) {
                returntype3_1 = true;
                returnDate3_1 = res03_type03.filter((a: any) => a.ProcessStatusID == "302")[0].ModifyDate;
                returnTXT3_1 = res03_type03.filter((a: any) => a.ProcessStatusID == "302")[0].StatusDefinitionCustPortal;
              }
              
              if (res03_type03.filter((a: any) => a.ProcessStatusID == "303").length > 0) {
                returntype3_1 = true;
                returnDate3_1 = res03_type03.filter((a: any) => a.ProcessStatusID == "303")[0].ModifyDate;
                returnTXT3_1 = res03_type03.filter((a: any) => a.ProcessStatusID == "303")[0].StatusDefinitionCustPortal;
              }
              
              if (res03_type03.filter((a: any) => a.ProcessStatusID == "306").length > 0) {
                returntype3_1 = true;
                returnDate3_1 = res03_type03.filter((a: any) => a.ProcessStatusID == "306")[0].ModifyDate;
                returnTXT3_1 = res03_type03.filter((a: any) => a.ProcessStatusID == "306")[0].StatusDefinitionCustPortal;
              }
              
              if (res03_type03.filter((a: any) => a.ProcessStatusID == "1003").length > 0) {
                returntype3_1 = true;
                returnDate3_1 = res03_type03.filter((a: any) => a.ProcessStatusID == "1003")[0].ModifyDate;
                returnTXT3_1 = res03_type03.filter((a: any) => a.ProcessStatusID == "1003")[0].StatusDefinitionCustPortal;
              }

              
              if (res03_type03.filter((a: any) => a.ProcessStatusID == "713").length > 0) {
                returntype3_2 = true;
                returnDate3_2 = res03_type03.filter((a: any) => a.ProcessStatusID == "713")[0].ModifyDate;
                returnTXT3_2 = res03_type03.filter((a: any) => a.ProcessStatusID == "713")[0].StatusDefinitionCustPortal;
              }
              
              if (res03_type03.filter((a: any) => a.ProcessStatusID == "714" && a.FilePath != null).length > 0) {
                if (Res.CRM05.length > 0) {
                  if (Res.CRM05.filter((a: any) => a.RequestedNo == res03_type03[0].RequestedNo).length > 0) {
                    returntype3_2 = true;
                    returnDate3_2 = res03_type03.filter((a: any) => a.ProcessStatusID == "714" && a.RequestedNo == res03_type03[0].RequestedNo)[0].ModifyDate;
                    returnTXT3_2 = res03_type03.filter((a: any) => a.ProcessStatusID == "714" && a.RequestedNo == res03_type03[0].RequestedNo)[0].StatusDefinitionCustPortal;
                  }
                }
              }
             

              if (res03_type03.filter((a: any) => a.ProcessStatusID == "715" && a.FilePath != null).length > 0) {
                returntype3_3 = true;
                returnDate3_3 = res03_type03.filter((a: any) => a.ProcessStatusID == "715")[0].ModifyDate;
                returnTXT3_3 = res03_type03.filter((a: any) => a.ProcessStatusID == "715")[0].StatusDefinitionCustPortal;
              }
              
              if (res03_type03.filter((a: any) => a.ProcessStatusID == "722").length > 0) {
                returntype3_3 = true;
                returnDate3_3 = res03_type03.filter((a: any) => a.ProcessStatusID == "722")[0].ModifyDate;
                returnTXT3_3 = res03_type03.filter((a: any) => a.ProcessStatusID == "722")[0].StatusDefinitionCustPortal;
              }


              if (res03_type03.filter((a: any) => a.ProcessStatusID == "603").length > 0) {
                returntype3_4 = true;
                returnDate3_4 = res03_type03.filter((a: any) => a.ProcessStatusID == "603")[0].ModifyDate;
                returnTXT3_4 = res03_type03.filter((a: any) => a.ProcessStatusID == "603")[0].StatusDefinitionCustPortal;
              }


              if (res03_type03.filter((a: any) => a.ProcessStatusID == "608").length > 0) {
                if (Res.CRM04.filter((a: any) => a.RequestedNo == res03_type03[0].RequestedNo && a.ChequeNo != "").length > 0) {
                  returntype3_5 = true;
                  returnDate3_5 = res03_type03.filter((a: any) => a.ProcessStatusID == "608" && a.RequestedNo == res03_type03[0].RequestedNo)[0].ModifyDate;
                  returnTXT3_5 = res03_type03.filter((a: any) => a.ProcessStatusID == "608" && a.RequestedNo == res03_type03[0].RequestedNo)[0].StatusDefinitionCustPortal;
                }
              }

              if (res03_type03.filter((a: any) => a.ProcessStatusID == "609").length > 0) {
                returntype3_5 = true;
                returnDate3_5 = res03_type03.filter((a: any) => a.ProcessStatusID == "609")[0].ModifyDate;
                returnTXT3_5 = res03_type03.filter((a: any) => a.ProcessStatusID == "609")[0].StatusDefinitionCustPortal;
              }


            }


          }

          let returntype4_1 = false;
          let returntype4_2 = false;
          let returntype4_3 = false;
          let returntype4_4 = false;
          let returntype4_5 = false;
          let returntype4_6 = false;
          let returntype4_6_1 = false;
          let returntype4_6_2 = false;
          let returnDate4_1 = "";
          let returnDate4_2 = "";
          let returnDate4_3 = "";
          let returnDate4_4 = "";
          let returnDate4_5 = "";
          let returnDate4_6 = "";
          let returnTXT4_1 = "";
          let returnTXT4_2 = "";
          let returnTXT4_3 = "";
          let returnTXT4_4 = "";
          let returnTXT4_5 = "";
          let returnTXT4_6 = "";
          let lastFinish4 = false;
          let lastFinish4_1 = false;
          let lastFinish4_2 = false;
          let res02_type04 = Res.CRM02.filter((a: any) => a.RequestTypeCode == 4)
          if (res02_type04.length > 0) {
            res02_type04.sort((firstObject: any, secondObject: any) => (new Date(secondObject.ModifyDate.substring(0, 19)).getTime() - new Date(firstObject.ModifyDate.substring(0, 19)).getTime()
            ));
            returnstep2 = true;
            let res03_type04 = Res.CRM03.filter((a: any) => a.RequestedNo == res02_type04[0].RequestedNo)
            if (res03_type04.length > 0) {
              lastFinish1 = false;

              if (res03_type04.filter((a: any) => a.ProcessStatusID == "301").length > 0) {
                returntype4_1 = true;
                returnDate4_1 = res03_type04.filter((a: any) => a.ProcessStatusID == "301")[0].ModifyDate;
                returnTXT4_1 = res03_type04.filter((a: any) => a.ProcessStatusID == "301")[0].StatusDefinitionCustPortal;
              }

              if (res03_type04.filter((a: any) => a.ProcessStatusID == "302").length > 0) {
                returntype4_1 = true;
                returnDate4_1 = res03_type04.filter((a: any) => a.ProcessStatusID == "302")[0].ModifyDate;
                returnTXT4_1 = res03_type04.filter((a: any) => a.ProcessStatusID == "302")[0].StatusDefinitionCustPortal;
              }

              if (res03_type04.filter((a: any) => a.ProcessStatusID == "306").length > 0) {
                returntype4_1 = true;
                returnDate4_1 = res03_type04.filter((a: any) => a.ProcessStatusID == "306")[0].ModifyDate;
                returnTXT4_1 = res03_type04.filter((a: any) => a.ProcessStatusID == "306")[0].StatusDefinitionCustPortal;
              }

              if (res03_type04.filter((a: any) => a.ProcessStatusID == "1004").length > 0) {
                returntype4_1 = true;
                returnDate4_1 = res03_type04.filter((a: any) => a.ProcessStatusID == "1004")[0].ModifyDate;
                returnTXT4_1 = res03_type04.filter((a: any) => a.ProcessStatusID == "1004")[0].StatusDefinitionCustPortal;
              }
              
              if (res03_type04.filter((a: any) => a.ProcessStatusID == "712").length > 0) {
                returntype4_2 = true;
                returnDate4_2 = res03_type04.filter((a: any) => a.ProcessStatusID == "712")[0].ModifyDate;
                returnTXT4_2 = res03_type04.filter((a: any) => a.ProcessStatusID == "712")[0].StatusDefinitionCustPortal;
              }

              
              if (res03_type04.filter((a: any) => a.ProcessStatusID == "717").length > 0) {
                returntype4_3 = true;
                returnDate4_3 = res03_type04.filter((a: any) => a.ProcessStatusID == "717")[0].ModifyDate;
                returnTXT4_3 = res03_type04.filter((a: any) => a.ProcessStatusID == "717")[0].StatusDefinitionCustPortal;
              }

              if (res03_type04.filter((a: any) => a.ProcessStatusID == "718" && a.FilePath != null).length > 0) {
                if (Res.CRM05.length > 0) {
                  if (Res.CRM05.filter((a: any) => a.RequestedNo == res03_type04[0].RequestedNo).length > 0) {
                    returntype4_4 = true;
                    returnDate4_4 = res03_type04.filter((a: any) => a.ProcessStatusID == "718" && a.RequestedNo == res03_type04[0].RequestedNo)[0].ModifyDate;
                    returnTXT4_4 = res03_type04.filter((a: any) => a.ProcessStatusID == "718" && a.RequestedNo == res03_type04[0].RequestedNo)[0].StatusDefinitionCustPortal;
                  }
                }
              }

              
              if (res03_type04.filter((a: any) => a.ProcessStatusID == "603").length > 0) {
                returntype4_5 = true;
                returnDate4_5 = res03_type04.filter((a: any) => a.ProcessStatusID == "603")[0].ModifyDate;
                returnTXT4_5 = res03_type04.filter((a: any) => a.ProcessStatusID == "603")[0].StatusDefinitionCustPortal;
              }


              if (res03_type04.filter((a: any) => a.ProcessStatusID == "608").length > 0) {
                if (Res.CRM04.filter((a: any) => a.RequestedNo == res03_type04[0].RequestedNo && a.ChequeNo != "").length > 0) {
                  returntype4_6 = true;
                  returnDate4_6 = res03_type04.filter((a: any) => a.ProcessStatusID == "608" && a.RequestedNo == res03_type04[0].RequestedNo)[0].ModifyDate;
                  returnTXT4_6 = res03_type04.filter((a: any) => a.ProcessStatusID == "608" && a.RequestedNo == res03_type04[0].RequestedNo)[0].StatusDefinitionCustPortal;
                }
              }

              if (res03_type04.filter((a: any) => a.ProcessStatusID == "609").length > 0) {
                returntype4_6 = true;
                returnDate4_6 = res03_type04.filter((a: any) => a.ProcessStatusID == "609")[0].ModifyDate;
                returnTXT4_6 = res03_type04.filter((a: any) => a.ProcessStatusID == "609")[0].StatusDefinitionCustPortal;
              }

              if (res03_type04.filter((a: any) => a.ProcessStatusID == "718").length > 0) {
                if (Res.CRM05.filter((a: any) => a.RequestedNo == res03_type04[0].RequestedNo && a.Result == "เรียกคืน").length > 0) {
                  returntype4_6_1 = true;
                  returnDate4_6 = res03_type04.filter((a: any) => a.ProcessStatusID == "718" && a.RequestedNo == res03_type04[0].RequestedNo)[0].ModifyDate;
                  returnTXT4_6 = res03_type04.filter((a: any) => a.ProcessStatusID == "718" && a.RequestedNo == res03_type04[0].RequestedNo)[0].StatusDefinitionCustPortal;
                }
              }

              if (res03_type04.filter((a: any) => a.ProcessStatusID == "718").length > 0) {
                if (Res.CRM05.filter((a: any) => a.RequestedNo == res03_type04[0].RequestedNo && a.Result == "เท่าเดิม").length > 0) {
                  returntype4_6_2 = true;
                  returnDate4_6 = res03_type04.filter((a: any) => a.ProcessStatusID == "718" && a.RequestedNo == res03_type04[0].RequestedNo)[0].ModifyDate;
                  returnTXT4_6 = res03_type04.filter((a: any) => a.ProcessStatusID == "718" && a.RequestedNo == res03_type04[0].RequestedNo)[0].StatusDefinitionCustPortal;
                }
              }

            }
          }

          if (returnstep2 == true) {
            if (returntype2_1) {
              Progress2_1 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate2_1, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate2_1, "shortWithTime") + '</div><p>ได้รับคำขอรับเงินแล้ว</p></div>';
              
              if (returnTXT2_1 == '')
                Progress2_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT2_1 + '</label></div></li>';
              else
                Progress2_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription2_1">รายละเอียด</label><label id="txtDescription2_1" class="collapse" style="padding-left:64px;">'+ returnTXT2_1 + '</label></div></div></li>';
              
              // Progress2 += '      <li class=""><label class="text status-active">ขอตรวจสอบ</label></li>'; 
            }

            if (returntype2_2) {
              let d1 = this.Util.transformDate(returnDate2_1, "shortWithTime");
              let d2 = this.Util.transformDate(returnDate2_2, "shortWithTime");
              if (d1 == '')
                d1 = d2;

              Progress2_1 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d1 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d1 + '</div><p>ได้รับคำขอรับเงินแล้ว</p></div>';
              Progress2_2 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d2 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle.png"><div class="divStep"><div class="divTimeTimeLine">' + d2 + '</div><p>อยู่ระหว่างพิจารณาคำขอรับเงิน</p></div>';
              
              if (returnTXT2_1 == '')
                Progress2_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT2_1 + '</label></div></li>';
              else
                Progress2_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription2_1">รายละเอียด</label><label id="txtDescription2_1" class="collapse" style="padding-left:64px;">'+ returnTXT2_1 + '</label></div></div></li>';
              
              if (returnTXT2_2 == '')
                Progress2_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT2_2 + '</label></div></li>';
              else
                Progress2_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription2_2">รายละเอียด</label><label id="txtDescription2_2" class="collapse" style="padding-left:64px;">'+ returnTXT2_2 + '</label></div></div></li>';
              
              
              //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
            }

            if (returntype2_3) {
              let d3 = this.Util.transformDate(returnDate2_3, "shortWithTime");
              let d2 = this.Util.transformDate(returnDate2_2, "shortWithTime");
              if (d2 == '')
                d2 = d3;

              Progress2_2 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d2 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d2 + '</div><p>อยู่ระหว่างพิจารณาคำขอรับเงิน</p></div>';
              Progress2_3 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d3 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d3 + '</div><p>พิจารณาคำขอรับเงินแล้วเสร็จ</p></div>';
              
              if (returnTXT2_2 == '')
                Progress2_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT2_2 + '</label></div></li>';
              else
                Progress2_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription2_2">รายละเอียด</label><label id="txtDescription2_2" class="collapse" style="padding-left:64px;">'+ returnTXT2_2 + '</label></div></div></li>';
              
              if (returnTXT2_3 == '')
                Progress2_3 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT2_3 + '</label></div></li>';
              else
                Progress2_3 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription2_3">รายละเอียด</label><label id="txtDescription2_3" class="collapse" style="padding-left:64px;">'+ returnTXT2_3 + '</label></div></div></li>';
                
              //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
            }
            
            if (returntype2_4) {
              Progress2_4 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate2_4, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate2_4, "shortWithTime") + '</div><p>อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</p></div>';
              
              if (returnTXT2_4 == '')
                Progress2_4 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT2_4 + '</label></div></li>';
              else
                Progress2_4 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription2_4">รายละเอียด</label><label id="txtDescription2_4" class="collapse" style="padding-left:64px;">'+ returnTXT2_4 + '</label></div></div></li>';
              
              //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
            }
            
            if (returntype2_5) {
              let d4 = this.Util.transformDate(returnDate2_4, "shortWithTime");
              let d5 = this.Util.transformDate(returnDate2_5, "shortWithTime");
              if (d4 == '')
                d4 = d5;

              Progress2_4 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d4 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d4 + '</div><p>อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</p></div>';
              Progress2_5 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d5 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d5 + '</div><p>จ่ายเงินคุ้มครองสำเร็จ</p></div>';
              
              if (returnTXT2_4 == '')
                Progress2_4 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT2_4 + '</label></div></li>';
              else
                Progress2_4 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription2_4">รายละเอียด</label><label id="txtDescription2_4" class="collapse" style="padding-left:64px;">'+ returnTXT2_4 + '</label></div></div></li>';
              
              if (returnTXT2_5 == '')
                Progress2_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT2_5 + '</label></div></li>';
              else
                Progress2_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription2_5">รายละเอียด</label><label id="txtDescription2_5" class="collapse" style="padding-left:64px;">'+ returnTXT2_5 + '</label></div></div></li>';
              
              
              //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
              lastFinish2 = true;
            }

            if (returntype3_1) {
              Progress3_1 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate3_1, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate3_1, "shortWithTime") + '</div><p>ได้รับคำขอรับเงินแล้ว</p></div>';
              
              if (returnTXT3_1 == '')
                Progress3_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT3_1 + '</label></div></li>';
              else
                Progress3_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription3_1">รายละเอียด</label><label id="txtDescription3_1" class="collapse" style="padding-left:64px;">'+ returnTXT3_1 + '</label></div></div></li>';
              
              // Progress2 += '      <li class=""><label class="text status-active">ขอตรวจสอบ</label></li>'; 
            }

            if (returntype3_2) {
              let d1 = this.Util.transformDate(returnDate3_1, "shortWithTime");
              let d2 = this.Util.transformDate(returnDate3_2, "shortWithTime");
              if (d1 == '')
                d1 = d2;

              Progress3_1 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d1 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d1 + '</div><p>ได้รับคำขอรับเงินแล้ว</p></div>';
              Progress3_2 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d2 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle.png"><div class="divStep"><div class="divTimeTimeLine">' + d2 + '</div><p>อยู่ระหว่างพิจารณาคำขอรับเงิน</p></div>';
             
              if (returnTXT3_1 == '')
                Progress3_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT3_1 + '</label></div></li>';
              else
                Progress3_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription3_1">รายละเอียด</label><label id="txtDescription3_1" class="collapse" style="padding-left:64px;">'+ returnTXT3_1 + '</label></div></div></li>';
                
              if (returnTXT3_2 == '')
                Progress3_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT3_2 + '</label></div></li>';
              else
                Progress3_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription3_2">รายละเอียด</label><label id="txtDescription3_2" class="collapse" style="padding-left:64px;">'+ returnTXT3_2 + '</label></div></div></li>';
              
              //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
            }

            if (returntype3_3) {
              let d3 = this.Util.transformDate(returnDate3_3, "shortWithTime");
              let d2 = this.Util.transformDate(returnDate3_2, "shortWithTime");
              if (d2 == '')
                d2 = d3;

              Progress3_2 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d2 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d2 + '</div><p>อยู่ระหว่างพิจารณาคำขอรับเงิน</p></div>';
              Progress3_3 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d3 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d3 + '</div><p>พิจารณาคำขอรับเงินแล้วเสร็จ</p></div>';
              
              if (returnTXT3_2 == '')
                Progress3_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT3_2 + '</label></div></li>';
              else
                Progress3_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription3_2">รายละเอียด</label><label id="txtDescription3_2" class="collapse" style="padding-left:64px;">'+ returnTXT3_2 + '</label></div></div></li>';
              
              if (returnTXT3_3 == '')
                Progress3_3 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT3_3 + '</label></div></li>';
              else
                Progress3_3 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription3_3">รายละเอียด</label><label id="txtDescription3_3" class="collapse" style="padding-left:64px;">'+ returnTXT3_3 + '</label></div></div></li>';
              
              //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
            }
            
            if (returntype3_4) {
              Progress3_4 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate3_4, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate3_4, "shortWithTime") + '</div><p>อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</p></div>';
              
              if (returnTXT3_4 == '')
                Progress3_4 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT3_4 + '</label></div></li>';
              else
                Progress3_4 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription3_4">รายละเอียด</label><label id="txtDescription3_4" class="collapse" style="padding-left:64px;">'+ returnTXT3_4 + '</label></div></div></li>';
              
              //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
            }
            
            if (returntype3_5) {
              Progress3_5 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate3_5, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate3_5, "shortWithTime") + '</div><p>จ่ายเงินคุ้มครองสำเร็จ</p></div>';
              
              if (returnTXT3_5 == '')
                Progress3_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT3_5 + '</label></div></li>';
              else
                Progress3_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription3_5">รายละเอียด</label><label id="txtDescription3_5" class="collapse" style="padding-left:64px;">'+ returnTXT3_5 + '</label></div></div></li>';
              

              //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
              lastFinish3 = true;
            }

            if (returntype4_1) {
              Progress4_1 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate4_1, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate4_1, "shortWithTime") + '</div><p>ได้รับคำขอตรวจสอบข้อมูลแล้ว</p></div>';
              
              if (returnTXT4_1 == '')
                Progress4_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT4_1 + '</label></div></li>';
              else
                Progress4_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription4_1">รายละเอียด</label><label id="txtDescription4_1" class="collapse" style="padding-left:64px;">'+ returnTXT4_1 + '</label></div></div></li>';
              
              //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
            }
            
            if (returntype4_2) {
              let d1 = this.Util.transformDate(returnDate4_1, "shortWithTime");
              let d2 = this.Util.transformDate(returnDate4_2, "shortWithTime");
              if (d1 == '')
                d1 = d2;

              Progress4_1 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d1 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d1 + '</div><p>ได้รับคำขอตรวจสอบข้อมูลแล้ว</p></div>';
              Progress4_2 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d2 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle.png"><div class="divStep"><div class="divTimeTimeLine">' + d2 + '</div><p>อยู่ระหว่างขอเอกสารเพิ่ม</p></div>';
              
              if (returnTXT4_1 == '')
                Progress4_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT4_1 + '</label></div></li>';
              else
                Progress4_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription4_1">รายละเอียด</label><label id="txtDescription4_1" class="collapse" style="padding-left:64px;">'+ returnTXT4_1 + '</label></div></div></li>';
              

              if (returnTXT4_2 == '')
                Progress4_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT4_2 + '</label></div></li>';
              else
                Progress4_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription4_2">รายละเอียด</label><label id="txtDescription4_2" class="collapse" style="padding-left:64px;">'+ returnTXT4_2 + '</label></div></div></li>';
              
              //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
            }            
            
            if (returntype4_3) {
              let d1 = this.Util.transformDate(returnDate4_1, "shortWithTime");
              let d2 = this.Util.transformDate(returnDate4_2, "shortWithTime");
              let d3 = this.Util.transformDate(returnDate4_3, "shortWithTime");
              if (d1 == '')
                d1 = d2;
              if (d2 == ''){
                d2 = d3; 
                d1 = d2;
              }

              Progress4_1 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d1 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d1 + '</div><p>ได้รับคำขอตรวจสอบข้อมูลแล้ว</p></div>';
              Progress4_3 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d3 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle.png"><div class="divStep"><div class="divTimeTimeLine">' + d3 + '</div><p>อยู่ระหว่างพิจารณาคำขอตรวจสอบข้อมูล</p></div>';
              
              if (returnTXT4_1 == '')
                Progress4_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT4_1 + '</label></div></li>';
              else
                Progress4_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription4_1">รายละเอียด</label><label id="txtDescription4_1" class="collapse" style="padding-left:64px;">'+ returnTXT4_1 + '</label></div></div></li>';
              

              if (returnTXT4_3 == '')
                Progress4_3 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT4_3 + '</label></div></li>';
              else
                Progress4_3 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription4_3">รายละเอียด</label><label id="txtDescription4_3" class="collapse" style="padding-left:64px;">'+ returnTXT4_3 + '</label></div></div></li>';

              
              if (returntype4_2) {
                Progress4_2 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d2 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d2 + '</div><p>อยู่ระหว่างขอเอกสารเพิ่ม</p></div>';
               
                if (returnTXT4_2 == '')
                  Progress4_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT4_2 + '</label></div></li>';
                else
                  Progress4_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription4_2">รายละเอียด</label><label id="txtDescription4_2" class="collapse" style="padding-left:64px;">'+ returnTXT4_2 + '</label></div></div></li>';
                
              }
              //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
            }
            
            if (returntype4_4) {
              let d3 = this.Util.transformDate(returnDate4_3, "shortWithTime");
              let d4 = this.Util.transformDate(returnDate4_4, "shortWithTime");
              if (d3 == '')
                d3 = d4;

              Progress4_3 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d3 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d3 + '</div><p>อยู่ระหว่างพิจารณาคำขอตรวจสอบข้อมูล</p></div>';
              Progress4_4 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d4 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d4 + '</div><p>พิจารณาคำขอตรวจสอบข้อมูลแล้วเสร็จ</p></div>';
             
              if (returnTXT4_3 == '')
                Progress4_3 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT4_3 + '</label></div></li>';
              else
                Progress4_3 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription4_3">รายละเอียด</label><label id="txtDescription4_3" class="collapse" style="padding-left:64px;">'+ returnTXT4_3 + '</label></div></div></li>';

              if (returnTXT4_4 == '')
                Progress4_4 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT4_4 + '</label></div></li>';
              else
                Progress4_4 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription4_4">รายละเอียด</label><label id="txtDescription4_4" class="collapse" style="padding-left:64px;">'+ returnTXT4_4 + '</label></div></div></li>';
              
             
              //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
            }

            if (returntype4_5) {
              Progress4_5 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate4_5, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate4_5, "shortWithTime") + '</div><p>อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</p></div>';
              
              if (returnTXT4_5 == '')
                Progress4_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT4_5 + '</label></div></li>';
              else
                Progress4_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription4_5">รายละเอียด</label><label id="txtDescription4_5" class="collapse" style="padding-left:64px;">'+ returnTXT4_5 + '</label></div></div></li>';
              
             //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
            }

            if (returntype4_6) {
              let d5 = this.Util.transformDate(returnDate4_5, "shortWithTime");
              let d6 = this.Util.transformDate(returnDate4_6, "shortWithTime");
              if (d5 == '')
                d5 = d6;

              Progress4_5 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d5 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d5 + '</div><p>อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</p></div>';
              Progress4_6 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d6 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d6 + '</div><p>จ่ายเงินคุ้มครองแล้วเสร็จ</p></div>';
              
              if (returnTXT4_5 == '')
                Progress4_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT4_5 + '</label></div></li>';
              else
                Progress4_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription4_5">รายละเอียด</label><label id="txtDescription4_5" class="collapse" style="padding-left:64px;">'+ returnTXT4_5 + '</label></div></div></li>';
              
              if (returnTXT4_6 == '')
                Progress4_6 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT4_6 + '</label></div></li>';
              else
                Progress4_6 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription4_6">รายละเอียด</label><label id="txtDescription4_6" class="collapse" style="padding-left:64px;">'+ returnTXT4_6 + '</label></div></div></li>';
              
              //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
              lastFinish4 = true;
            }
            if (returntype4_6_1) {
              Progress4_6 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate4_6, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate4_6, "shortWithTime") + '</div><p>เรียกคืนเงินคุ้มครอง</p></div>';
              
              if (returnTXT4_6 == '')
                Progress4_6 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT4_6 + '</label></div></li>';
              else
                Progress4_6 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription4_6">รายละเอียด</label><label id="txtDescription4_6" class="collapse" style="padding-left:64px;">'+ returnTXT4_6 + '</label></div></div></li>';
              
              //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
              lastFinish4_1 = true;
            }
            if (returntype4_6_2) {
              Progress4_6 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate4_6, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate4_6, "shortWithTime") + '</div><p>การจ่ายเงินคุ้มครองถูกต้องแล้ว</p></div>';
              
              if (returnTXT4_6 == '')
                Progress4_6 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT4_6 + '</label></div></li>';
              else
                Progress4_6 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription4_6">รายละเอียด</label><label id="txtDescription4_6" class="collapse" style="padding-left:64px;">'+ returnTXT4_6 + '</label></div></div></li>';
              
              //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
              lastFinish4_2 = true;
            }
          }

          let returntype5_1 = false;
          let returntype5_2 = false;
          let returntype5_3 = false;
          let returntype5_4 = false;
          let returntype5_5 = false;
          let returntype5_5_1 = false;
          let returntype5_5_2 = false;
          let returnDate5_1 = "";
          let returnDate5_2 = "";
          let returnDate5_3 = "";
          let returnDate5_4 = "";
          let returnDate5_5 = "";
          let returnTXT5_1 = "";
          let returnTXT5_2 = "";
          let returnTXT5_3 = "";
          let returnTXT5_4 = "";
          let returnTXT5_5 = "";
          let lastFinish5 = false;
          let lastFinish5_1 = false;
          let lastFinish5_2 = false;
          let res02_type05 = Res.CRM02.filter((a: any) => a.RequestTypeCode == 5)
          if (res02_type05.length > 0) {
            res02_type05.sort((firstObject: any, secondObject: any) => (new Date(secondObject.ModifyDate.substring(0, 19)).getTime() - new Date(firstObject.ModifyDate.substring(0, 19)).getTime()
            ));
            let res03_type05 = Res.CRM03.filter((a: any) => a.RequestedNo == res02_type05[0].RequestedNo)
            if (res03_type05.length > 0) {

              lastFinish1 = false;
              lastFinish2 = false;
              lastFinish3 = false;
              lastFinish4 = false;
              lastFinish4_1 = false;
              lastFinish4_2 = false;

              
              if (res03_type05.filter((a: any) => a.ProcessStatusID == "301").length > 0) {
                returntype5_1 = true;
                returnDate5_1 = res03_type05.filter((a: any) => a.ProcessStatusID == "301")[0].ModifyDate;
                returnTXT5_1 = res03_type05.filter((a: any) => a.ProcessStatusID == "301")[0].StatusDefinitionCustPortal;
              }
              
              if (res03_type05.filter((a: any) => a.ProcessStatusID == "302").length > 0) {
                returntype5_1 = true;
                returnDate5_1 = res03_type05.filter((a: any) => a.ProcessStatusID == "302")[0].ModifyDate;
                returnTXT5_1 = res03_type05.filter((a: any) => a.ProcessStatusID == "302")[0].StatusDefinitionCustPortal;
              }
              
              if (res03_type05.filter((a: any) => a.ProcessStatusID == "303").length > 0) {
                returntype5_1 = true;
                returnDate5_1 = res03_type05.filter((a: any) => a.ProcessStatusID == "303")[0].ModifyDate;
                returnTXT5_1 = res03_type05.filter((a: any) => a.ProcessStatusID == "303")[0].StatusDefinitionCustPortal;
              }
              
              if (res03_type05.filter((a: any) => a.ProcessStatusID == "306").length > 0) {
                returntype5_1 = true;
                returnDate5_1 = res03_type05.filter((a: any) => a.ProcessStatusID == "306")[0].ModifyDate;
                returnTXT5_1 = res03_type05.filter((a: any) => a.ProcessStatusID == "306")[0].StatusDefinitionCustPortal;
              }

              if (res03_type05.filter((a: any) => a.ProcessStatusID == "1004").length > 0) {
                returntype5_1 = true;
                returnDate5_1 = res03_type05.filter((a: any) => a.ProcessStatusID == "1004")[0].ModifyDate;
                returnTXT5_1 = res03_type05.filter((a: any) => a.ProcessStatusID == "1004")[0].StatusDefinitionCustPortal;
              }
              

              if (res03_type05.filter((a: any) => a.ProcessStatusID == "717").length > 0) {
                returntype5_2 = true;
                returnDate5_2 = res03_type05.filter((a: any) => a.ProcessStatusID == "717")[0].ModifyDate;
                returnTXT5_2 = res03_type05.filter((a: any) => a.ProcessStatusID == "717")[0].StatusDefinitionCustPortal;
              }


              if (res03_type05.filter((a: any) => a.ProcessStatusID == "718" && a.FilePath != null).length > 0) {
                if (Res.CRM05.length > 0) {
                  if (Res.CRM05.filter((a: any) => a.RequestedNo == res03_type05[0].RequestedNo).length > 0) {
                    returntype5_3 = true;
                    returnDate5_3 = res03_type05.filter((a: any) => a.ProcessStatusID == "718" && a.RequestedNo == res03_type05[0].RequestedNo)[0].ModifyDate;
                    returnTXT5_3 = res03_type05.filter((a: any) => a.ProcessStatusID == "718" && a.RequestedNo == res03_type05[0].RequestedNo)[0].StatusDefinitionCustPortal;
                  }
                }
              }


              if (res03_type05.filter((a: any) => a.ProcessStatusID == "603").length > 0) {
                returntype5_4 = true;
                returnDate5_4 = res03_type05.filter((a: any) => a.ProcessStatusID == "603")[0].ModifyDate;
                returnTXT5_4 = res03_type05.filter((a: any) => a.ProcessStatusID == "603")[0].StatusDefinitionCustPortal;
              }


              if (res03_type05.filter((a: any) => a.ProcessStatusID == "608").length > 0) {
                if (Res.CRM04.filter((a: any) => a.RequestedNo == res03_type05[0].RequestedNo && a.ChequeNo != "").length > 0) {
                  returntype5_5 = true;
                  returnDate5_5 = res03_type05.filter((a: any) => a.ProcessStatusID == "608" && a.RequestedNo == res03_type05[0].RequestedNo)[0].ModifyDate;
                  returnTXT5_5 = res03_type05.filter((a: any) => a.ProcessStatusID == "603" && a.RequestedNo == res03_type05[0].RequestedNo)[0].StatusDefinitionCustPortal;
                }
              }

              if (res03_type05.filter((a: any) => a.ProcessStatusID == "609").length > 0) {
                returntype5_5 = true;
                returnDate5_5 = res03_type05.filter((a: any) => a.ProcessStatusID == "609")[0].ModifyDate;
                returnTXT5_5 = res03_type05.filter((a: any) => a.ProcessStatusID == "609")[0].StatusDefinitionCustPortal;
              }

              if (res03_type05.filter((a: any) => a.ProcessStatusID == "718").length > 0) {
                if (Res.CRM05.filter((a: any) => a.RequestedNo == res03_type05[0].RequestedNo && a.Result == "เรียกคืน").length > 0) {
                  returntype5_5_1= true;
                  returnDate5_5 = res03_type05.filter((a: any) => a.ProcessStatusID == "718" && a.RequestedNo == res03_type05[0].RequestedNo)[0].ModifyDate;
                  returnTXT5_5 = res03_type05.filter((a: any) => a.ProcessStatusID == "718" && a.RequestedNo == res03_type05[0].RequestedNo)[0].StatusDefinitionCustPortal;
                }
              }

              if (res03_type05.filter((a: any) => a.ProcessStatusID == "718").length > 0) {
                if (Res.CRM05.filter((a: any) => a.RequestedNo == res03_type05[0].RequestedNo && a.Result == "เท่าเดิม").length > 0) {
                  returntype5_5_2 = true;
                  returnDate5_5 = res03_type05.filter((a: any) => a.ProcessStatusID == "718" && a.RequestedNo == res03_type05[0].RequestedNo)[0].ModifyDate;
                  returnTXT5_5 = res03_type05.filter((a: any) => a.ProcessStatusID == "718" && a.RequestedNo == res03_type05[0].RequestedNo)[0].StatusDefinitionCustPortal;
                }
              }

            }

            if (returntype5_1) {
              Progress5_1 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate5_1, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate5_1, "shortWithTime") + '</div><p>ได้รับคำขออุทธรณ์แล้ว</p></div>';
              
              if (returnTXT5_1 == '')
                Progress5_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT5_1 + '</label></div></li>';
              else
                Progress5_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription5_1">รายละเอียด</label><label id="txtDescription5_1" class="collapse" style="padding-left:64px;">'+ returnTXT5_1 + '</label></div></div></li>';
              
              //Progress2 += '      <label class="text status-active">อุทธรณ์</label>'; 
            }
            
            if (returntype5_2) {
              let d1 = this.Util.transformDate(returnDate5_1, "shortWithTime");
              let d2 = this.Util.transformDate(returnDate5_2, "shortWithTime");
              if (d1 == '')
                d1 = d2;

              Progress5_1 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d1 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d1 + '</div><p>ได้รับคำขออุทธรณ์แล้ว</p></div>';
              Progress5_2 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d2 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle.png"><div class="divStep"><div class="divTimeTimeLine">' + d2 + '</div><p>อยู่ระหว่างพิจารณาคำขออุทธรณ์</p></div>';
              
              if (returnTXT5_1 == '')
                Progress5_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT5_1 + '</label></div></li>';
              else
                Progress5_1 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription5_1">รายละเอียด</label><label id="txtDescription5_1" class="collapse" style="padding-left:64px;">'+ returnTXT5_1 + '</label></div></div></li>';
              
              if (returnTXT5_2 == '')
                Progress5_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT5_2 + '</label></div></li>';
              else
                Progress5_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription5_2">รายละเอียด</label><label id="txtDescription5_2" class="collapse" style="padding-left:64px;">'+ returnTXT5_2 + '</label></div></div></li>';
              
              //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
              
            }

            if (returntype5_3)  {
              let d3 = this.Util.transformDate(returnDate5_3, "shortWithTime");
              let d2 = this.Util.transformDate(returnDate5_2, "shortWithTime");
              if (d2 == '')
                d2 = d3;

              Progress5_2 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d2 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d2 + '</div><p>อยู่ระหว่างพิจารณาคำขออุทธรณ์</p></div>';
              Progress5_3 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d3 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d3 + '</div><p>พิจารณาคำขออุทธรณ์แล้วเสร็จ</p></div>';
              
              if (returnTXT5_2 == '')
                Progress5_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT5_2 + '</label></div></li>';
              else
                Progress5_2 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription5_2">รายละเอียด</label><label id="txtDescription5_2" class="collapse" style="padding-left:64px;">'+ returnTXT5_2 + '</label></div></div></li>';
              

              if (returnTXT5_3 == '')
                Progress5_3 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT5_3 + '</label></div></li>';
              else
                Progress5_3 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription5_3">รายละเอียด</label><label id="txtDescription5_3" class="collapse" style="padding-left:64px;">'+ returnTXT5_3 + '</label></div></div></li>';
              
              //Progress2 += '      <li class=""><label class="text status-active">อุทธรณ์</label></li>'; 
            }
            
            if (returntype5_4)  {
              Progress5_4 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate5_4, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate5_4, "shortWithTime") + '</div><p>อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</p></div>';
              
              if (returnTXT5_4 == '')
                Progress5_4 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT5_4 + '</label></div></li>';
              else
                Progress5_4 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription5_4">รายละเอียด</label><label id="txtDescription5_4" class="collapse" style="padding-left:64px;">'+ returnTXT5_4 + '</label></div></div></li>';
             
               //Progress2 += '      <li class=""><label class="text status-active">อุทธรณ์</label></li>'; 
            }

            if (returntype5_5)  {
              let d4 = this.Util.transformDate(returnDate5_4, "shortWithTime");
              let d5 = this.Util.transformDate(returnDate5_5, "shortWithTime");
              if (d4 == '')
                d4 = d5;

              Progress5_4 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d4 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d4 + '</div><p>อยู่ระหว่างดำเนินการจ่ายเงินคุ้มครอง</p></div>';
              Progress5_5 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + d5 + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + d5 + '</div><p>จ่ายเงินคุ้มครองเพิ่มเติมสำเร็จ</p></div>';
              
              if (returnTXT5_4 == '')
                Progress5_4 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT5_4 + '</label></div></li>';
              else
                Progress5_4 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription5_4">รายละเอียด</label><label id="txtDescription5_4" class="collapse" style="padding-left:64px;">'+ returnTXT5_4 + '</label></div></div></li>';
             
              if (returnTXT5_5 == '')
                Progress5_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT5_5 + '</label></div></li>';
              else
                Progress5_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription5_5">รายละเอียด</label><label id="txtDescription5_5" class="collapse" style="padding-left:64px;">'+ returnTXT5_5 + '</label></div></div></li>';
              
              //Progress2 += '      <li class=""><label class="text status-active">อุทธรณ์</label></li>'; 
              lastFinish5 = true;
            }

            if (returntype5_5_1) {
              Progress5_5 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate5_5, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate5_5, "shortWithTime") + '</div><p>เรียกคืนเงินคุ้มครอง</p></div>';
              
              if (returnTXT5_5 == '')
                Progress5_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT5_5 + '</label></div></li>';
              else
                Progress5_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription5_5">รายละเอียด</label><label id="txtDescription5_5" class="collapse" style="padding-left:64px;">'+ returnTXT5_5 + '</label></div></div></li>';
              
                //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
              lastFinish5_1 = true;
            }

            
            if (returntype5_5_2) {
              Progress5_5 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate5_5, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate5_5, "shortWithTime") + '</div><p>การจ่ายเงินคุ้มครองถูกต้องแล้ว</p></div>';
              
              if (returnTXT5_5 == '')
                Progress5_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;">'+ returnTXT5_5 + '</label></div></li>';
              else
                Progress5_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription5_5">รายละเอียด</label><label id="txtDescription5_5" class="collapse" style="padding-left:64px;">'+ returnTXT5_5 + '</label></div></div></li>';
              
               //Progress2 += '      <label class="text status-active">ขอตรวจสอบ</label>'; 
              lastFinish5_2 = true;
            }
          }

          let arr1 = Res.CRM03.map((obj: any) => { return { ...obj, date: new Date(obj.ModifyDate) }; });
          let sortedDesc = arr1.sort((objA: any, objB: any) => (objB.RequestTypeCode - objA.RequestTypeCode || objB.date.getTime() - objA.date.getTime()));

          StatusText1 = sortedDesc[0].StatusDefinitionCustPortal
          StatusText2 = this.Util.transformDate(sortedDesc[0].ModifyDate.substring(0, 10), "short");

          this.contactDros = Res;
          //this.drawTableStatus();

          /*
                    if (Res.CRM02.filter((a: any) => a.RequestedNo.substr(0, 1) == "V").length > 0) {
                      // Progress1 += '      <li class="active step0"><img src="../../assets/images/status1_active.png"></li>';
                      // Progress1 += '      <li class="active step0"><img src="../../assets/images/status2_active.png"></li>';
                      // Progress2 += '      <li class="active step0"><label class="text status-active">จ่ายคืน</label></li>';
                      // Progress2 += '      <li class="active step0"><label class="text status-active">ขอตรวจสอบ</label></li>';
                      if (Res.CRM02.filter((a: any) => a.RequestedNo.substr(0, 1) == "A").length > 0) {
                        Progress1 += '      <li class="active step0"><img src="../../assets/images/status1_active.png"></li>';
                        Progress1 += '      <li class="active step0"><img src="../../assets/images/status2_active.png"></li>';
                        Progress2 += '      <li class="active step0"><label class="text status-active">จ่ายคืน</label></li>';
                        Progress2 += '      <li class="active step0"><label class="text status-active">ขอตรวจสอบ</label></li>';
                        if (Res.CRM05.length == 0) {
                          Progress1 += '      <li class="step0"><img src="../../assets/images/status1.png"></li>'
                          Progress2 += '      <li class="step0"><label class="text status-inactive">อุทธรณ์</label></li>';
                          let Rec = Res.CRM02.filter((a: any) => a.RequestedNo.substr(0, 1) == "A")[0];
                          StatusText1 = Rec.RequestType;
                          StatusText2 = "";
                        }
                        else {
                          if (Res.CRM05.filter((a: any) => a.RequestedNo.substr(0, 1) == "A").length > 0) {
                            Progress1 += '      <li class="active step0"><img src="../../assets/images/status1_active.png"></li>'
                            Progress2 += '      <li class="active step0"><label class="text status-active">อุทธรณ์</label></li>';
                            let LastDate: Date;
                            Res.CRM05.filter((a: any) => a.RequestedNo.substr(0, 1) == "A").forEach((a: any) => {
                              if (LastDate == null || LastDate == undefined) {
                                LastDate = new Date(a.ModifyDate.substring(0, 19));
                                StatusText1 = a.StatusDefinitionCustPortal;
                                //StatusText2 = this.Util.ConvertToBE(LastDate.getDate() + "/" + (LastDate.getMonth() + 1) + "/" + LastDate.getFullYear());
                                StatusText2 = this.Util.transformDate(a.ModifyDate.substring(0, 10), "short");
                              }
                              else {
                                if (new Date(a.ModifyDate.substring(0, 19)) > LastDate) {
                                  LastDate = new Date(a.ModifyDate.substring(0, 19));
                                  StatusText1 = a.StatusDefinitionCustPortal;
                                  //StatusText2 = this.Util.ConvertToBE(LastDate.getDate() + "/" + (LastDate.getMonth() + 1) + "/" + LastDate.getFullYear());
                                  StatusText2 = this.Util.transformDate(a.ModifyDate.substring(0, 10), "short");
                                }
                              }
                            });
                          }
                          else {
                            Progress1 += '      <li class="step0"><img src="../../assets/images/status1.png"></li>'
                            Progress2 += '      <li class="step0"><label class="text status-inactive">อุทธรณ์</label></li>';
                            let LastDate: Date;
                            Res.CRM05.filter((a: any) => a.RequestedNo.substr(0, 1) == "V").forEach((a: any) => {
                              if (LastDate == null || LastDate == undefined) {
                                LastDate = new Date(a.ModifyDate.substring(0, 19));
                                StatusText1 = a.StatusDefinitionCustPortal;
                                //StatusText2 = this.Util.ConvertToBE(LastDate.getDate() + "/" + (LastDate.getMonth() + 1) + "/" + LastDate.getFullYear());
                                StatusText2 = this.Util.transformDate(a.ModifyDate.substring(0, 10), "short");
                              }
                              else {
                                if (new Date(a.ModifyDate.substring(0, 19)) > LastDate) {
                                  LastDate = new Date(a.ModifyDate.substring(0, 19));
                                  StatusText1 = a.StatusDefinitionCustPortal;
                                  //StatusText2 = this.Util.ConvertToBE(LastDate.getDate() + "/" + (LastDate.getMonth() + 1) + "/" + LastDate.getFullYear());
                                  StatusText2 = this.Util.transformDate(a.ModifyDate.substring(0, 10), "short");
                                }
                              }
                            });
                          }
                        }
                      }
                      else {
                        Progress1 += '      <li class="active step0"><img src="../../assets/images/status1_active.png"></li>';
                        Progress2 += '      <li class="active step0"><label class="text status-active">จ่ายคืน</label></li>';
                        if (Res.CRM05.length == 0) {
                          Progress1 += '      <li class="step0"><img src="../../assets/images/status2.png"></li>';
                          Progress2 += '      <li class="step0"><label class="text status-inactive">ขอตรวจสอบ</label></li>';
                          let Rec = Res.CRM02.filter((a: any) => a.RequestedNo.substr(0, 1) == "V")[0];
                          StatusText1 = Rec.RequestType;
                          StatusText2 = "";
                        }
                        else {
                          Progress1 += '      <li class="active step0"><img src="../../assets/images/status2_active.png"></li>';
                          Progress2 += '      <li class="active step0"><label class="text status-active">ขอตรวจสอบ</label></li>';
                          let LastDate: Date;
                          Res.CRM05.filter((a: any) => a.RequestedNo.substr(0, 1) == "V").forEach((a: any) => {
                            if (LastDate == null || LastDate == undefined) {
                              LastDate = new Date(a.ModifyDate.substring(0, 19));
                              StatusText1 = a.StatusDefinitionCustPortal;
                              //StatusText2 = this.Util.ConvertToBE(LastDate.getDate() + "/" + (LastDate.getMonth() + 1) + "/" + LastDate.getFullYear());
                              StatusText2 = this.Util.transformDate(a.ModifyDate.substring(0, 10), "short");
                            }
                            else {
                              if (new Date(a.ModifyDate.substring(0, 19)) > LastDate) {
                                LastDate = new Date(a.ModifyDate.substring(0, 19));
                                StatusText1 = a.StatusDefinitionCustPortal;
                                //StatusText2 = this.Util.ConvertToBE(LastDate.getDate() + "/" + (LastDate.getMonth() + 1) + "/" + LastDate.getFullYear());
                                StatusText2 = this.Util.transformDate(a.ModifyDate.substring(0, 10), "short");
                              }
                            }
                          });
                        }
                      }
                    }
                    else {
                      if (Res.CRM02.filter((a: any) => a.RequestedNo.substr(0, 1) == "I").length > 0) {
                        Progress1 += '      <li class="active step0"><img src="../../assets/images/status1_active.png"></li>';
                        Progress2 += '      <li class="active active0 step0"><label class="text status-active">จ่ายคืน</label></li>';
                        if (Res.CRM03.length > 0) {
                          let LastDate: Date;
                          Res.CRM03.forEach((a: any) => {
                            if (a.RequestedNo.substring(0, 1) == "I") {
                              if (LastDate == null || LastDate == undefined) {
                                LastDate = new Date(a.ModifyDate.substring(0, 19));
                                StatusText1 = a.StatusDefinitionCustPortal;
                                //StatusText2 = this.Util.ConvertToBE(LastDate.getDate() + "/" + (LastDate.getMonth() + 1) + "/" + LastDate.getFullYear());
                                StatusText2 = this.Util.transformDate(a.ModifyDate.substring(0, 10), "short");
                              }
                              else {
                                if (new Date(a.ModifyDate.substring(0, 19)) > LastDate) {
                                  LastDate = new Date(a.ModifyDate.substring(0, 19));
                                  StatusText1 = a.StatusDefinitionCustPortal;
                                  //StatusText2 = this.Util.ConvertToBE(LastDate.getDate() + "/" + (LastDate.getMonth() + 1) + "/" + LastDate.getFullYear());
                                  StatusText2 = this.Util.transformDate(a.ModifyDate.substring(0, 10), "short");
                                }
                              }
                            }
                          });
                        }
                      }
                      else {
                        Progress1 += '      <li class="step0"><img src="../../assets/images/status1.png"></li>';
                        Progress2 += '      <li class="active0 step0"><label class="text status-inactive">จ่ายคืน</label></li>';
                        StatusText1 = Res.CRM02[0].RequestType;
                        StatusText2 = "";
                      }
                    }
          
                    */
                   
          /*if (lastFinish5_2) {
            Progress5_5 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate5_5, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/checked.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate5_5, "shortWithTime") + '</div><p>การจ่ายเงินคุ้มครองถูกต้องแล้ว</p></div>'; 
            Progress5_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription">รายละเอียด</label><label id="txtDescription" class="collapse" style="padding-left:64px;">'+ returnTXT5_5 + '</label></div></div></li>';
          }
          else if (lastFinish5_1) {
            Progress5_5 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate5_5, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/checked.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate5_5, "shortWithTime") + '</div><p>เรียกคืนเงินคุ้มครอง</p></div>';
            Progress5_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription">รายละเอียด</label><label id="txtDescription" class="collapse" style="padding-left:64px;">'+ returnTXT5_5 + '</label></div></div></li>';
          }
          else if (lastFinish5) {
            Progress5_5 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate5_5, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/checked.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate5_5, "shortWithTime") + '</div><p>จ่ายเงินคุ้มครองเพิ่มเติมสำเร็จ</p></div>';
            Progress5_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription">รายละเอียด</label><label id="txtDescription" class="collapse" style="padding-left:64px;">'+ returnTXT5_5 + '</label></div></div></li>';
          }
          else if (lastFinish4_2) {
            Progress4_6 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate4_6, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/checked.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate4_6, "shortWithTime") + '</div><p>การจ่ายเงินคุ้มครองถูกต้องแล้ว</p></div>';            
            Progress4_6 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription">รายละเอียด</label><label id="txtDescription" class="collapse" style="padding-left:64px;">'+ returnTXT4_6 + '</label></div></div></li>';
          }
          else if (lastFinish4_1) {
            Progress4_6 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate4_6, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/checked.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate4_6, "shortWithTime") + '</div><p>เรียกคืนเงินคุ้มครอง</p></div>';
            Progress4_6 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription">รายละเอียด</label><label id="txtDescription" class="collapse" style="padding-left:64px;">'+ returnTXT4_6 + '</label></div></div></li>';
          }
          else if (lastFinish4) {
            Progress4_6 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate4_6, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/checked.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate4_6, "shortWithTime") + '</div><p>จ่ายเงินคุ้มครองแล้วเสร็จ</p></div>';  
            Progress4_6 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription">รายละเอียด</label><label id="txtDescription" class="collapse" style="padding-left:64px;">'+ returnTXT4_6 + '</label></div></div></li>';
          }
          else if (lastFinish3) {
            Progress3_5 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate3_5, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/checked.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate3_5, "shortWithTime") + '</div><p>จ่ายเงินคุ้มครองสำเร็จ</p></div>';           
            Progress3_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription">รายละเอียด</label><label id="txtDescription" class="collapse" style="padding-left:64px;">'+ returnTXT3_5 + '</label></div></div></li>';
          }
          else if (lastFinish2) {
            Progress2_5 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate2_5, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/checked.png"><div class="divStep"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate2_5, "shortWithTime") + '</div><p>จ่ายเงินคุ้มครองสำเร็จ</p></div>';
            Progress2_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription">รายละเอียด</label><label id="txtDescription" class="collapse" style="padding-left:64px;">'+ returnTXT2_5 + '</label></div></div></li>';
          }
          else if (lastFinish1) {
            Progress1_5 = '      <li><p class="pTimeTimeLine" style="margin-left:35px;width:180px">' + this.Util.transformDate(returnDate1_5, "shortWithTime") + '</p><img width="61" style="background-color: white;" src="../../assets/images/checked.png"><div class="divStepLast"><div class="divTimeTimeLine">' + this.Util.transformDate(returnDate1_5, "shortWithTime") + '</div><p>จ่ายเงินคุ้มครองสำเร็จ </p></div>';
            Progress1_5 += '<div class="divider blue"><div style="padding-bottom:30px"><label style="padding-left:64px;cursor: pointer;" data-toggle="collapse" data-target="#txtDescription">รายละเอียด</label><label id="txtDescription" class="collapse" style="padding-left:64px;">'+ returnTXT1_5 + '</label></div></div></li>';
          }*/

          //ProgressDiv += Progress1_1 + Progress1_2 + Progress1_3+ Progress1_4 + Progress1_5;
          //ProgressDiv += Progress2_1 + Progress2_2 + Progress2_3+ Progress2_4 + Progress2_5;
          //ProgressDiv += Progress3_1 + Progress3_2 + Progress3_3+ Progress3_4 + Progress3_5;
          //ProgressDiv += Progress4_1 + Progress4_2 + Progress4_3+ Progress4_4 + Progress4_5;
          //ProgressDiv += Progress5_1 + Progress5_2 + Progress5_3+ Progress5_4 + Progress5_5;
          //ProgressDiv += '    </ul>';
          //ProgressDiv += '  </div>';
          //ProgressDiv += '</div>';

          ProgressDiv += Progress5_5 + Progress5_4 + Progress5_3 + Progress5_2 + Progress5_1;
          ProgressDiv += Progress4_6 + Progress4_5 + Progress4_4 + Progress4_3 + Progress4_2 + Progress4_1;
          ProgressDiv += Progress3_5 + Progress3_4 + Progress3_3 + Progress3_2 + Progress3_1;
          ProgressDiv += Progress2_5 + Progress2_4 + Progress2_3 + Progress2_2 + Progress2_1;
          ProgressDiv += Progress1_5 + Progress1_4 + Progress1_3 + Progress1_2 + Progress1_1;

          $("#progress").append(ProgressDiv);
          $('#progress li > div').last().remove();

          
        if ($('#progress li img:first(childs)')[0].src.indexOf('circle_1.png') > 0)
          $('#progress li img:first(childs)')[0].src= '../../assets/images/checked.png';

        
          //$("#divProgress").append(ProgressDiv);
          $("#lblInquiryResult1").html(StatusText1);
          $("#lblInquiryResult2").html(StatusText2 == "" ? "" : ("เมื่อวันที่ " + StatusText2));
          //$("#divProgress").append(Progress2);
          $("#divInquiry").addClass("hidden");
          $("#divResult").removeClass("hidden");
          $("#txtName").val(Res.CRM07[0].Name);
          $("#txtIDNo").val(Res.CRM07[0].IDNo);
          $("#txtAccNo").val(Res.CRM07[0].BankAccountNo);

          // $("#lblName").html(Res.CRM07[0].Name);
          // $("#lblIDNo").html(Res.CRM07[0].IDNo);
          // $("#lblAccNo").html(Res.CRM07[0].BankAccountNo);
        }
        else {
          this.Util.WarningDialog("ไม่พบข้อมูล กรุณาติดต่อ Call Center DPA 1158");
        }
      }
    }
    catch (err) {
      console.log(err);
      this.Util.WarningDialog("ไม่พบข้อมูล กรุณาติดต่อ Call Center DPA 1158");
    }
  }

  Back() {
    $("#divInquiry").removeClass("hidden");
    $("#divResult").addClass("hidden");
  }

  ClearText() {
    $("#IdNo").val("");
    $("#AccNo").val("");
  }
}



// WEBPACK FOOTER //
// ./src/app/status-tracking/status-tracking.component.ts